import {getItemType} from "@/utils/utils";
import {CONTENT_TYPES} from "@/constants";
import dynamic from "next/dynamic";
import React from "react";

const Audio   = dynamic(() => import('@/components/common/Audio'),   {
	loading: () => null,
	ssr: false
});

const DownloadFiles   = dynamic(() => import('@/components/downloadFiles/DownloadFiles'),   {
	loading: () => null,
	ssr: false
});

const Button   = dynamic(() => import('@/components/Archive/StructuredText/Button'),   {
	loading: () => null,
	ssr: false
});

const Block = ({ data, color='' }) => {
	const type = getItemType(data)
	switch (type) {
		case CONTENT_TYPES.AUDIO_FILE:
			return <Audio url={data?.source?.url || ''}/>
		case CONTENT_TYPES.DOWNLOAD_FILES:
			return <DownloadFiles data={data} textColor={color} />
		case CONTENT_TYPES.BUTTON:
			return <Button data={data}/>
		default:
			return  null
	}
};

export default Block;
